import {
  FaCertificate,
  FaChalkboardTeacher,
  FaLeaf,
  FaSearch,
  FaTruck,
  FaTshirt,
  FaUtensils,
} from "react-icons/fa";

/**
 * Decorative UI icons for the Services page areas.
 * These are illustrative only — they are not certification marks.
 */
export const servicesIcons = {
  certificate: FaCertificate,
  food: FaUtensils,
  sustainability: FaLeaf,
  textile: FaTshirt,
  supplyChain: FaTruck,
  training: FaChalkboardTeacher,
  gap: FaSearch,
};

export default servicesIcons;
